import axiosClient from './axiosService';

const BASE_URL = '/progress';

export const getAllProgress = () =>
    axiosClient.get(BASE_URL);

export const getProgressById = (id) =>
    axiosClient.get(`${BASE_URL}/${id}`);

export const createProgress = (progress) =>
    axiosClient.post(BASE_URL, progress);

export const updateProgress = (id, progress) =>
    axiosClient.put(`${BASE_URL}/${id}`, progress);

export const updateProgressStatus = (id, statusData) => {
    if (typeof statusData === 'string') {
        // Old way - just status as string
        return axiosClient.put(`${BASE_URL}/${id}/status`, {
            progressStatus: statusData,
        });
    } else if (typeof statusData === 'object') {
        // New way - object with progressStatus and comments
        return axiosClient.put(`${BASE_URL}/${id}/status`, statusData);
    }
};

export const deleteProgress = (id) =>
    axiosClient.delete(`${BASE_URL}/${id}`);

export const getProgressByStudentId = (studentId) =>
    axiosClient.get(`${BASE_URL}/student/${studentId}`);

export const getProgressByStudyId = (studyId) =>
    axiosClient.get(`${BASE_URL}/study/${studyId}`);

export const getTotalProgressCount = () =>
    axiosClient.get(`${BASE_URL}/count`);

export const getLatest5ProgressByStudentId = (studentId) =>
    axiosClient.get(`${BASE_URL}/latest/5/${studentId}`);

export const getProgressByProgressDate = (progressDate) =>
    axiosClient.get(`${BASE_URL}/progressDate`, {
        params: { progressDate },
    });

export const getProgressByStudyCompletion = (studyComplition) =>
    axiosClient.get(`${BASE_URL}/studyComplition`, {
        params: { studyComplition },
    });

export const getProgressBySubmitThesis = (submitThesis) =>
    axiosClient.get(`${BASE_URL}/submitThesis`, {
        params: { submitThesis },
    });

export const getProgressByMeetSupervisor = (meetSupervisor) =>
    axiosClient.get(`${BASE_URL}/meetSupervisor`, {
        params: { meetSupervisor },
    });

export const getProgressBySupervisorResponse = (supervisorResponse) =>
    axiosClient.get(`${BASE_URL}/supervisorResponse`, {
        params: { supervisorResponse },
    });

export const getProgressCountByStudentId = (studentId) =>
    axiosClient.get(`${BASE_URL}/count/student/${studentId}`);


export const uploadProgressFile = async (id, file) => {
    const formData = new FormData();
    formData.append("file", file);

    return axiosClient.post(
        `/progress/${id}/upload`,
        formData,
        {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }
    );
};

export const getProgressFile = (filename) => {
    // return `http://localhost:8285/progress/file/${filename}`;
    return `https://hetras.suza.ac.tz/hetras/progress/file/${filename}`;
};
